import Component from '../vendor/Component'

export default class SetDefaultAddress extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
  }

  mount() {
    this._elem.addEventListener('click', async e => {
      console.log('works')
      e.preventDefault()
      let form = document.querySelector(this._options.target)
      if (form) {
        let defaultCheckbox = form.querySelector('input[name="address[default]"]')
        defaultCheckbox.checked = true
        form.submit()
      }
    })
  }
}